import script from "./RegisterContent.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterContent.vue?vue&type=script&setup=true&lang=js"

import "./RegisterContent.vue?vue&type=style&index=0&id=5b6383c8&lang=css"
import "./RegisterContent.vue?vue&type=style&index=1&id=5b6383c8&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b6383c8"]])

export default __exports__